import apiClient from "./middleware";
import { devPreviewEmailForRequests } from "../utils/userAccess";

export interface HomeSummaryScope {
  kind: "mine" | "all" | "managers";
  managerEmails: string[];
}

export interface IssueBreakdown {
  total: number;
  byIssue: Record<string, number>;
}

export interface NetworkHealthSummary {
  scope: HomeSummaryScope;
  metadata: IssueBreakdown | null;
  claims: IssueBreakdown | null;
  musicLabelIssues: number;
  options: { legalEntityTypes: string[]; contentFormats: string[] };
  dataUpdatedAt: string | null;
  generatedAt: string;
}

export interface TitleQcSummary {
  scope: HomeSummaryScope;
  openIssues: number;
  highPriority: number;
  needsManualReview: number;
  networkOpenIssues: number;
  acceptedTotal: number;
  rejectedTotal: number;
  applyFailedTotal: number;
  byVideoType: Record<string, number>;
  latestRun: {
    runId: string;
    dateCreated: string;
    status: string;
    openIssuesWritten: number | null;
  } | null;
  options: { videoTypes: string[]; languages: string[] };
  generatedAt: string;
}

export interface BannerSwapSummary {
  scope: HomeSummaryScope;
  liveNow: number;
  upcoming: number;
  needsAttention: number;
  channelsInScope: number;
  channelsWithoutDefault: number;
  nextUpcoming: Array<{
    swapUID: string;
    swapName: string;
    startDate: string;
    channelCount: number;
  }>;
  windowDays: number;
  generatedAt: string;
}

type Params = Record<string, string | number | boolean | undefined>;

const clean = (params: Params) =>
  Object.fromEntries(
    Object.entries({ ...params, asEmail: devPreviewEmailForRequests() }).filter(
      ([, v]) => v !== undefined && v !== ""
    )
  );

export const homeSummaryApi = {
  getNetworkHealth: async (params: Params): Promise<NetworkHealthSummary> => {
    const response = await apiClient.get("/home-summary/network-health", {
      params: clean(params),
    });
    return response.data;
  },
  getTitleQc: async (params: Params): Promise<TitleQcSummary> => {
    const response = await apiClient.get("/home-summary/title-qc", {
      params: clean(params),
    });
    return response.data;
  },
  getBannerSwap: async (params: Params): Promise<BannerSwapSummary> => {
    const response = await apiClient.get("/home-summary/banner-swap", {
      params: clean(params),
    });
    return response.data;
  },
};
